import MainComponent from "components/Main";
import PropTypes from 'prop-types';

import Calendar from "../../../../components/Calendar";

import { ReactComponent as ArrowIcon } from 'icons/components/arrow.svg';

import './index.less';
import './themes/default.less';

export default class CalendarAdvanced extends MainComponent {
    static propTypes = {
        value: PropTypes.instanceOf(Date),
        interval: PropTypes.number,
        onChange: PropTypes.func,
        selectedDays: PropTypes.array,
    };
    static defaultProps = {
        value: "",
        interval: 1,
        onChange: null,
        selectedDays: [],
    };

    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            opened: false,
            firstSelected: true,
            value1: new Date(),
            value2: null,
            interval1: this.props.interval,
            interval2: 0

        };
    }

    componentDidUpdate() {
        this.setSecondCalendarHeight(this.state.opened);
    }

    onChange(firstSelected, date) {
        const value1 = firstSelected ? date : this._helper.date.addMonth(date, -1);
        const value2 = !firstSelected ? date : this._helper.date.addMonth(date, 1);

        const interval1 = firstSelected ? this.props.interval : 0;
        const interval2 = !firstSelected ? this.props.interval : 0;

        this.setState({ firstSelected, value1, value2, interval1, interval2 });

        if (this.props.onChange)
            this.props.onChange(date);
    }

    onCalendarFirstMonthChange(value1) {
        const value2 = this._helper.date.addMonth(value1, 1);
        //const value2 = null;

        this.setState({ value1, value2 });
    }

    toggleOpened() {
        const opened = !this.state.opened;

        if (this.wasScrolled) {
            this.setScrollState(false);
            return;
        }

        if (!opened && !this.state.firstSelected) {
            const { h } = this._helper.dom.coords(this.firstCalendarCont);

            this.setScrollState(true, -(h + 24) + "px");
            return;
        }

        this.setState({ opened }, this.setSecondCalendarHeight.bind(this, opened));
    }

    setScrollState(flag, height) {
        this._helper.dom.style(this.firstCalendarCont, "marginTop", !flag ? "0px" : height);

        this._helper.dom.removeClass(this.arrow, !flag ? "rotate90" : "rotate90m");
        this._helper.dom.addClass(this.arrow, !flag ? "rotate90m" : "rotate90");

        this.wasScrolled = flag;
    }

    setSecondCalendarHeight(opened) {
        let h = 0;
        if (opened)
            h = this._helper.dom.coords(this.secondCalendar.domNode).h;

        this._helper.dom.style(this.secondCalendarCont, "height", h + "px");
    }

    render() {
        const { value, selectedDays } = this.props;
        const { opened, value1, value2, firstSelected, interval1, interval2 } = this.state;
        //const val1 = value1 || value;
        const val1 = value1;
        const val2 = value2 || this._helper.date.addMonth(value, 1);

        /*let val2 = null;
        if (value2 === undefined || value2 === null)
            val2 = value2 || this._helper.date.addMonth(value, 1);
        else if (value2 === "")
            val2 = null;
        else if (value2) {
            val2 = value2;
        }*/

        const rotate = opened ? "rotate90m" : "rotate90";
        const cl = opened ? "opened" : "";

        return (
            <div className="calendarAdvanced flex col hidden">
                <div className="first transit06" ref={el => this.firstCalendarCont = el}>
                    <Calendar
                        value={val1}
                        selected={firstSelected ? value : ""}
                        interval={interval1}
                        onChange={this.onChange.bind(this, true)}
                        onMonthChange={this.onCalendarFirstMonthChange.bind(this)}
                        selectedDays={selectedDays}
                    />
                </div>
                <div className={`second transit06 hidden ${cl}`} ref={el => this.secondCalendarCont = el} >
                    <Calendar
                        ref={el => this.secondCalendar = el}
                        value={val2}
                        interval={interval2}
                        selected={!firstSelected ? value : ""}
                        onChange={this.onChange.bind(this, false)}
                        showArrows={false}
                        selectedDays={selectedDays}
                    />
                </div>
                <div
                    className="arrowButton flex centerAll rad4 hand"
                    onClick={this.toggleOpened.bind(this)}
                >
                    <ArrowIcon className={rotate} ref={el => this.arrow = el} />
                </div>
            </div>
        );
    }
}
